import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';
import { Tooltip } from '@material-ui/core';

import palette from 'theme/palette';
import SlateNewData from './SlateNewData';
import SlateMate from './SlateMate';
import SlateDialog from 'components/Shared/SlateDialog/SlateDialog';
import generateUUID from 'helpers/generateUUID';
import './styles.css';

class SlateGenerator extends Component {
  state = {
    uuid: generateUUID(),
    qrDialogOpen: false,
  };

  render() {
    var t = this.props.t;
    var uuid = this.state.uuid;
    var qrDialogOpen = this.state.qrDialogOpen;

    return (
      <div className="inner-page slate-generator-page">
        <div className="slate-generator-header">
          <h1 className="slate-generator-header-title">
            {t('slateGenerator:slateGenerator')}
            {' '}
            <img className="slatemate-logo slatemate-logo--light" src="/images/SlateMate-Logo.svg" alt="SlateMate" />
            <img className="slatemate-logo slatemate-logo--dark" src="/images/SlateMate-Logo-DarkMode.svg" alt="SlateMate" />
          </h1>
          <Tooltip title={t('slateGenerator:qrCodeTooltip')} placement="top">
            <div className="slate-generator-qr-btn">
              <RaisedButton
                icon={
                  <span
                    className="material-symbols-outlined"
                    style={{ fontSize: 20, lineHeight: 1, color: palette.cardTitle, position: 'relative', top: -1 }}
                  >
                    qr_code_2
                  </span>
                }
                style={{ minWidth: 40, height: 36 }}
                onClick={this.openQrDialog}
              />
            </div>
          </Tooltip>
        </div>

        <div className="slate-generator-body">
          <SlateMate t={t} />
        </div>

        <SlateDialog
          open={qrDialogOpen}
          onClose={this.closeQrDialog}
          title={t('slateGenerator:qrDialogTitle')}
          actions={[
            {
              label: t('slateGenerator:generateNewSlate'),
              onClick: this.generateNewSlate,
              variant: 'primary',
            },
          ]}
        >
          <div className="slate-generator-section">
            <div className="slate-generator-warning">
              <span className="material-symbols-outlined slate-generator-warning-icon">info</span>
              <span>{t('slateGenerator:warning')}</span>
            </div>
            <SlateNewData uuid={uuid} t={t} />
          </div>
        </SlateDialog>
      </div>
    );
  }

  openQrDialog = () => {
    this.setState({
      qrDialogOpen: true,
      uuid: generateUUID(),
    });
  };

  closeQrDialog = () => {
    this.setState({ qrDialogOpen: false });
  };

  generateNewSlate = () => {
    this.setState({
      uuid: generateUUID(),
    });
  };
}

export default withTranslation()(SlateGenerator);
